import React, { useCallback, useState } from "react";
import { HeartIcon } from "@heroicons/react/solid";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Button from "../Button";
import { ENDPOINT, Routes } from "../../constants";
import { InputField } from "../InputField";
import { FetchApi } from "../../api/fetch";

const VerifyEmailLayout = () => {
  const history = useHistory();
  const [code, setCode] = useState('')
  const [isSending, setIsSending] = useState(false)

  const goToLogin = useCallback(() => {
    history.push(Routes.LOGIN);
  }, [history]);

  const resendCode = async () => {
    setIsSending(true)
    const username = sessionStorage.getItem('loggedUser') || ''
    try {
      await FetchApi({
        endpoint: `${ENDPOINT.BASE_AUTH}/resend-verification`,
        method: "POST",
        body:  ({
          email: username,
        }),
      })
      toast.success('Code Resent')

    } catch (error: any) {
      // toast.error(error.message)
    }
    setIsSending(false)
  }

  const confirmSignUp = async (e: any) => {
    e.preventDefault()
    setIsSending(true)
    const username = sessionStorage.getItem('loggedUser') || ''

    try {
      await FetchApi({
        endpoint:`${ENDPOINT.BASE_AUTH}/confirm-verification`, 
        method: "POST",
        body:  ({
          email: username,
          code
        }),
      })
      goToLogin()

    } catch (error: any) {
      toast.error(error.message)
    }
    setIsSending(false)
  }

  return (
    <div className="flex-col max-w-4xl mx-auto px-2 mt-8 sm:px-6 lg:px-4  lg:mt-32">
      <p className="mb-4 text-lg font-light text-center lg:text-2xl">
        Welcome to Kyzzen Creator Portal
      </p>

      <div className="md:shadow-lg flex flex-col items-center">
        <HeartIcon className="h-28 w-28 mb-2" aria-hidden="true" />
        {/* <h1 className="font-black text-3xl text-center mb-6">THANK YOU</h1> */}
        <p className="mb-8 mt-8 text-lg font-light text-center lg:text-2xl">
          A verification code has been sent to your email, please verify the email
          to activate your account.
        </p>
        <form onSubmit={confirmSignUp}>
          <InputField
            type="text"
            onChange={(e) => setCode(e.target.value)}
            value={code}
            required
            name="code"
            placeholder="####"
            label="Verification Code"
          />
          <Button type="submit" disabled={isSending} className="mb-8 w-full btn btn-primary" onClick={confirmSignUp}>
            Verify
          </Button>
        </form>
        <Button type="button" disabled={isSending} className="mb-8 w-full" onClick={resendCode}>
          {isSending ? 'Please wait ...' : ' Resend Code'}
        </Button>
      </div>
    </div>
  );
};

export default VerifyEmailLayout;